import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getStorage, type FirebaseStorage } from 'firebase/storage';
import { getFunctions, type Functions } from 'firebase/functions';

const region = 'asia-south1';

function requiredEnv(key: keyof ImportMetaEnv): string {
  const v = import.meta.env[key];
  if (!v || String(v).trim() === '') {
    throw new Error(
      `Missing ${String(key)}. Copy web/.env.example to web/.env and add Firebase Web app config.`,
    );
  }
  return String(v).trim();
}

let appInstance: FirebaseApp | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (appInstance) return appInstance;
  appInstance = initializeApp({
    apiKey: requiredEnv('VITE_FIREBASE_API_KEY'),
    authDomain: requiredEnv('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: requiredEnv('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: requiredEnv('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: requiredEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: requiredEnv('VITE_FIREBASE_APP_ID'),
  });
  return appInstance;
}

export function auth(): Auth {
  return getAuth(getFirebaseApp());
}

export function db(): Firestore {
  return getFirestore(getFirebaseApp());
}

export function storage(): FirebaseStorage {
  return getStorage(getFirebaseApp());
}

/** Matches `lib/firebase_functions_region.dart` — Mumbai. */
export function functions(): Functions {
  return getFunctions(getFirebaseApp(), region);
}
